import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from 'components/Buttons';

import { ButtonColorScheme, ButtonType } from "types/ui";

type ConfirmModalType = {
  open: boolean;
  onClose: () => void;
  onAccept: () => void | Promise<void>;
  title?: React.ReactNode;
  content?: React.ReactNode;
  acceptButtonText?: string;
  cancelButtonText?: string;
};

const ConfirmModal: React.FC<ConfirmModalType> = ({
  open,
  onClose,
  onAccept,
  title = 'Delete item',
  content = 'Are you sure?',
  acceptButtonText = 'Accept',
  cancelButtonText = 'Cancel',
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOnAccept = async () => {
    try {
      setIsLoading(true);
      await onAccept();
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnClose = () => {
    if (isLoading) {
      return;
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleOnClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>{content}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          title={acceptButtonText}
          onClick={handleOnAccept}
          type={ButtonType.normal}
          colorScheme={isLoading ? ButtonColorScheme.disabled : ButtonColorScheme.gradient}
          disabled={isLoading}
        />

        <Button
          title={cancelButtonText}
          onClick={handleOnClose}
          type={ButtonType.normal}
          colorScheme={isLoading ? ButtonColorScheme.disabled : ButtonColorScheme.danger}
          disabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
